import { Box } from "@mui/joy";
import TaskHeader from "../header/TaskHeader";
import { useRecoilState, useRecoilValue } from "recoil";
import { paymentOrderAtom } from "recoil/paymentOrderAtom";
import { useQuery } from "@tanstack/react-query";
import {
  PAYMENT_DOMAIN,
  PAYMENT_ORDER_DETAIL_ENDPOINT,
  paymentApi,
} from "api/paymentApi";
import React, { useEffect } from "react";
import { userAtom } from "recoil/userAtom";
import useIsInappWebview from "hooks/useIsInappWebview";
import TransparentHeader from "../header/TransparentHeader";
import { pcSideTabAtom } from "../../../recoil/pcSideTabAtom";
import PaymentContent100Day365 from "./PaymentContent100Day365";
import PaymentContent100DayABCPlan from "./PaymentContent100DayABCPlan";
import PaymentContent100DayABCPlanChallenger395 from "./PaymentContent100DayABCPlanChallenger395";
import PaymentContent100DayABCPlanChallenger395Master465 from "./PaymentContent100DayABCPlanChallenger395Master465";
import PaymentContent100DayKoreanMania from "./PaymentContent100DayKoreanMania";
import PaymentContent100DayABCPlanChallenger395Master465WithCommitment from "./PaymentContent100DayABCPlanChallenger395Master465WithCommitment";

export default function Payment() {
  const [paymentOrderState, setPaymentOrderState] =
    useRecoilState(paymentOrderAtom);
  const user = useRecoilValue(userAtom);
  const isInappWebview = useIsInappWebview();
  const pcSideTab = useRecoilValue(pcSideTabAtom);

  const { refetch: getPaymentOrder } = useQuery(
    [PAYMENT_DOMAIN, PAYMENT_ORDER_DETAIL_ENDPOINT],
    () => paymentApi.getOrderDetail(),
    {
      enabled: false,
      onSuccess: (data) => {
        if (data && data.result) {
          setPaymentOrderState(data.result);
        }
      },
    }
  );

  useEffect(() => {
    if (user?.accessToken) {
      getPaymentOrder();
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        {isInappWebview ? (
          <TransparentHeader />
        ) : (
          pcSideTab === "home" && <TaskHeader taskKey={"payment"} />
        )}
      </Box>
      {paymentOrderState && user && (
        <div className="w-full h-full overflow-x-hidden">
          {user.isCarePass === true ? (
            <PaymentContent100Day365 />
          ) : user.pricingModel === "abf" ? (
            <PaymentContent100DayABCPlan />
          ) : user.pricingModel === "aef" ? (
            <PaymentContent100DayABCPlanChallenger395 />
          ) : user?.pricingModel === "aeg" && user?.refundPolicyType === "c" ? (
            <PaymentContent100DayABCPlanChallenger395Master465WithCommitment />
          ) : user.pricingModel === "aeg" ? (
            <PaymentContent100DayABCPlanChallenger395Master465 />
          ) : user.pricingModel === "koreanmania" ? (
            <PaymentContent100DayKoreanMania />
          ) : (
            <PaymentContent100Day365 />
          )}
        </div>
      )}
    </>
  );
}
